import "./styles/base.css";      // global defaults
import "tenant/theme.css";       // tenant overrides
 
// Ensure NativeBridge is installed before react mounts.
import "./utils/parentAppBridgeInstall";
import "./utils/nativeJwtExchange";

// Initialize i18n before React renders
import "./i18n/config";

import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import { store } from "./store/store";
import App from "./App";
import { SessionProvider } from "./session/SessionCtx";
import { IdpSkipProvider } from "./auth/IdpSkipCtx";

import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react'

// If console logging is NOT enabled, monkey patch console methods to do nothing.
if (import.meta.env.VITE_CONSOLE_LOGGING_ENABLED !== "true") {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  // console.warn = () => {};
  // console.error = () => {};
}

posthog.init(import.meta.env.VITE_POSTHOG_API_KEY, {
  api_host: "https://us.i.posthog.com",
  defaults: '2025-05-24',
});

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <Provider store={store}>
        <BrowserRouter>
          <SessionProvider>
            <IdpSkipProvider>
              <App />
            </IdpSkipProvider>
          </SessionProvider>
        </BrowserRouter>
      </Provider>
    </PostHogProvider>
  </React.StrictMode>
);
